

import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";


export default function ProductDetailDescription({ initialData }) {
  const mainRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const { product_detail_slug } = useParams();
  const [aiData, setAiData] = React.useState(initialData || []);
  const navigate = useNavigate();


  const mainSettings = {
    arrows: false,
    dots: false,
    // autoplay: false,
    // autoplaySpeed: 4000,
    // speed: 5000,
    swipe: false,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    arrows: false,
    dots: false,
    slidesToShow: 4,
    // autoplaySpeed: 4000,
    // speed: 5000,
    vertical: true,
    swipe: false,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          vertical: false,
          swipe: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  const handleThumbClick = (index) => {
    setActiveIndex(index);
    mainRef.current.slickGoTo(index);
  };


  // APi Fetching
  const aifetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/product/view/${product_detail_slug}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (!result.product) {
        navigate("/404");
        return;
      }
      setAiData(result.product);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  React.useEffect(() => {
    aifetcher();
  }, [product_detail_slug])




  return (
    <>
      <section className="product-detail">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ul className="dynamic-breadcrumb">
                <li> <Link to={"/"}> Home</Link></li>
                <li> <Link to={`/product-listing/${aiData?.category_slug}`} >{aiData?.category_name}</Link></li>
                <li>  <Link> {aiData?.title?.slice(0, 20)}...</Link></li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="product-image-wrap">
                <Slider {...thumbSettings} className="product-thumbs">
                  {aiData?.images && aiData?.images?.map((img, i) => (
                    <div key={i} className="thumb-item">
                      <img src={img?.image ? `${BaseUrl}${img.image}` : undefined} onClick={() => handleThumbClick(i)} className={activeIndex === i ? "active" : ""} alt={img?.alt_image} />
                    </div>
                  ))}
                </Slider>
                <div className="product-main-wrapper">
                  <Slider {...mainSettings} ref={mainRef}>
                    {aiData?.images && aiData?.images?.map((img, i) => (
                      <div key={i}>
                        <img src={img?.image ? `${BaseUrl}${img.image}` : undefined} onClick={() => handleThumbClick(i)} className={activeIndex === i ? "active" : ""} alt={img?.alt_image} />
                      </div>
                    ))}
                  </Slider>
                </div>

              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-6">
              <div className="product-info">
                {aiData?.title && <h1 className="heading"> {aiData?.title} </h1>}
                {aiData?.description && <div className="product-desc" dangerouslySetInnerHTML={{ __html: aiData?.description }} />}
                {aiData?.brand && <p><span className="title">Brand : </span> {aiData?.brand}</p>}
                {aiData?.model_number && <p><span className="title">Model Number : </span>  {aiData?.model_number} </p>}
                {aiData?.capacity && <p><span className="title">Capacity : </span> {aiData?.capacity} </p>}
                <div className="btn-box">
                  <Link to="/contact" className="default-btn">
                    <span >enquire now</span>
                  </Link>
                  <a className="default-btn white-btn" target="_blank" href={aiData?.pdf_brochure ? `${BaseUrl}${aiData.pdf_brochure}` : undefined} download>
                    <span >Download brochure</span>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="specifications-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 specifications-wrap">
              <h2 className="heading">Specifications</h2>
              <div className="spec-grid">
                <ul className="spec-list">
                  {aiData?.specifications &&
                    aiData.specifications.filter((item, index) => index % 2 === 0)
                      .map((item, index) => (
                        <li key={index}>
                          <span>{item.title}</span>
                          <strong>{item.value}</strong>
                        </li>
                      ))}
                </ul>

                <ul className="spec-list">
                  {aiData?.specifications &&
                    aiData.specifications
                      .filter((item, index) => index % 2 !== 0)
                      .map((item, index) => (
                        <li key={index}>
                          <span>{item.title}</span>
                          <strong>{item.value}</strong>
                        </li>
                      ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="product-description">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 description-wrap">
              <img src={aiData?.banner_image ? `${BaseUrl}${aiData.banner_image}` : undefined} loading="lazy" className="img-responsive description-img" alt={aiData?.banner_image} />
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}



